<template>
  <div
    class="back-button"
    @click="navigateBack">
    <span class="back-icon">&#8592;</span>
    {{ buttonText }}
  </div>
</template>

<script>
export default {
  name: 'BackButton',
  props: {
    to: {
      type: String,
    },
    text: {
      type: String,
      default: '',
    },
  },
  computed: {
    buttonText() {
      return this.text ? this.text : this.$t('back');
    },
  },
  methods: {
    navigateBack() {
      if (this.to) {
        this.$router.push(this.to);
      } else {
        this.$router.go(-1);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.back-button {
  width: fit-content;
  display: inline-flex;
  align-items: center;
  padding: 10px 20px;
  margin-bottom: 20px;
  color: #fff;
  border: none;
  border-radius: 5px;
  text-decoration: none;
  transition: background-color 0.3s ease;
  background-color: #27645c;
  cursor: pointer;
}

.back-button:hover {
  background-color: darkgray;
}

.back-icon {
  margin-right: 5px;
}
</style>
